import { Schema } from 'effect';

import type { OrderItems } from '../../../bind/order';
import { GtmSelectPromotionEventSchema } from '@vs-shop/schemas/gtm/select-promotion';
import type { ProductForGTM } from './cart-items-update';

type SelectPromotionPayloadFromOrder = {
  id: string;
  name?: string;
  creativeName?: string;
  creativeSlot?: string;
};

export const createSelectPromotionPayloadFromOrder = (
  promotion: SelectPromotionPayloadFromOrder,
  items: OrderItems
) => {
  return Schema.decodeEffect(GtmSelectPromotionEventSchema)({
    event: 'select_promotion',
    ecommerce: {
      creative_name: promotion.creativeName,
      creative_slot: promotion.creativeSlot,
      promotion_id: promotion.id,
      promotion_name: promotion.name,
      items: items.map((item) => {
        const orderItemProduct = item.variant.product;
        return {
          id: item.variant.code,
          name: item.productName ?? '',
          price: (item.variant.priceWithoutTax ?? 0) / 100,
          price_with_tax: (item.frontUnitPriceWithVat ?? 0) / 100,
          quantity: item.quantity,
          brand: orderItemProduct.brand?.name ?? undefined,
          categories:
            orderItemProduct.mainTaxon?.code !== undefined
              ? [orderItemProduct.mainTaxon.code]
              : undefined,
        };
      }),
    },
  });
};

export const createSelectPromotionPayloadFromProduct = (
  promotion: SelectPromotionPayloadFromOrder,
  product: ProductForGTM,
  amount: number
) => {
  const productPriceAmount = product.priceWithoutTax / 100;

  return Schema.decodeEffect(GtmSelectPromotionEventSchema)({
    event: 'select_promotion',
    ecommerce: {
      creative_name: promotion.creativeName,
      creative_slot: promotion.creativeSlot,
      promotion_id: promotion.id,
      promotion_name: promotion.name,
      items: [
        {
          id: product.code,
          name: product.name,
          brand: product.brand?.name ?? undefined,
          categories: product.mainTaxonCode ? [product.mainTaxonCode] : undefined,
          price: productPriceAmount,
          price_with_tax: product.price / 100,
          quantity: amount,
        },
      ],
    },
  });
};
